import { useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Content, Header, Main } from "../commons/Template/Template";
import { Form, FormLoader } from "../commons/Form/Form";
import { Input } from "../commons/Form/Form";
import authAPI from "../../api/authentication";
import routes from "../../routes/routes";
import { useAuth } from "../../auth/AuthContext";
import { OnboardingPasswordSet } from "../Onboarding/Onboarding";
import Typo, { Em } from "../commons/Typo/Typo";

// Allow user to insert e-mail address to request a password-reset e-mail
export default function PasswordResetKickOff({ onboardingEmail = "" }) {
  const { t } = useTranslation(["common", "account", "onboarding"]);
  const { logged } = useAuth();

  document.title = !onboardingEmail
    ? t("account:passwordResetKickOff.title")
    : t("onboarding:password.heading");

  const [pending, setPending] = useState(false);

  const [email, setEmail] = useState(onboardingEmail);
  const [emailError, setEmailError] = useState([]);

  const [loading, setLoading] = useState(onboardingEmail ? true : false);

  useEffect(() => {
    if (onboardingEmail) {
      handlePasswordResetRequest();
    }
  }, [onboardingEmail]);

  const handlePasswordResetRequest = async () => {
    const response = await authAPI.requestPasswordResetEMail(email);
    if (!response.ok) {
      setEmailError(["Une erreur s'est produite."]);
      setLoading(false);
      return;
    }
    setPending(true);
    setLoading(false);
  };

  const emailInput = {
    label: t("common:email"),
    name: "email",
    type: "email",
    value: email,
    onChange: setEmail,
  };

  if (loading) return <FormLoader />;
  if (onboardingEmail) return <OnboardingPasswordSet />;

  return (
    <Main>
      <Header>
        <Typo variant="h1">
          <Trans
            t={t}
            i18nKey="account:passwordResetKickOff.heading"
            components={{
              emphasis: <Em />,
            }}
          />
        </Typo>

        <Typo variant="body2">
          {loading ? (
            <FormLoader />
          ) : pending ? (
            <>
              <span>
                <Trans
                  t={t}
                  i18nKey="account:passwordResetKickOff.pending.subheading"
                  components={{
                    anchor: <Link to={`mailto:${routes.EmailSupport}`} />,
                    emphasis: <strong />,
                  }}
                />
              </span>
              <CheckLogged logged={logged} />
            </>
          ) : (
            <>
              <span>
                <Trans
                  t={t}
                  i18nKey="account:passwordResetKickOff.kickoff.subheading"
                  components={{
                    anchor: <Link to={`mailto:${routes.EmailSupport}`} />,
                  }}
                />
              </span>
              <CheckLogged logged={logged} />
            </>
          )}
        </Typo>
      </Header>
      <Content>
        {loading ? (
          <></>
        ) : (
          !pending && (
            <Form errors={emailError} onSubmit={handlePasswordResetRequest}>
              <Input {...emailInput} />
            </Form>
          )
        )}
      </Content>
    </Main>
  );
}

// Add "remark" component with current logged user, if any
export function CheckLogged({ logged }) {
  const [user, setUser] = useState("");
  const { t } = useTranslation();

  const getUser = async () => {
    const response = await authAPI.getUserInfo();
    if (response.status === 200) {
      setUser(`${response.data.user.name} ${response.data.user.surname}`);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  if (logged) {
    return (
      <strong>
        {t("account:passwordResetKickOff.remark")}{" "}
        <span className="user">{user}</span>
      </strong>
    );
  }

  return <></>;
}
